module.exports = {
  title: 'Pomodoro Timer with Reanimated',
  author: 'Enzo Manuel Mangano',
  date: '2024-08-20',
  slug: 'pomodoro-timer',
  tags: ['reanimated'],
};
